/**
 * Validation Patterns Constants
 * 유효성 검사 정규식 패턴 상수
 */

/** 이메일 정규식 패턴 */
export const EMAIL_REGEX = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

/** 전화번호 정규식 패턴 (10-12자리 숫자) */
export const PHONE_REGEX = /^\d{10,12}$/;

/** 비밀번호 정규식 패턴 (영문, 숫자, 특수문자 포함 8자 이상) */
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

/** 숫자만 허용 정규식 */
export const NUMBER_ONLY_REGEX = /^[0-9]+$/;

/** 금액 정규식 (콤마 포함 숫자) */
export const AMOUNT_REGEX = /^[0-9,]+$/;

/**
 * 이메일 유효성 검사
 * @param email 이메일 주소
 */
export const isValidEmail = (email: string): boolean => {
    return EMAIL_REGEX.test(email);
};

/**
 * 전화번호 유효성 검사
 * @param phone 전화번호
 */
export const isValidPhone = (phone: string): boolean => {
    return PHONE_REGEX.test(phone);
};

/**
 * 비밀번호 유효성 검사
 * @param password 비밀번호
 */
export const isValidPassword = (password: string): boolean => {
    return PASSWORD_REGEX.test(password);
};
